import { createFileRoute } from "@tanstack/react-router";
import { TermlyPolicyPage } from "@/knowmeno/TermlyPolicyPage";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Cookie Policy — KnowMeno" },
      { name: "description", content: "How KnowMeno uses cookies and similar technologies to keep you signed in, remember preferences, and measure how the product is used." },
      { property: "og:title", content: "Cookie Policy — KnowMeno" },
      { property: "og:description", content: "How KnowMeno uses cookies and similar technologies to keep you signed in, remember preferences, and measure how the product is used." },
      { property: "og:url", content: "https://knowmeno.com/cookies" },
    ],
    links: [
      { rel: "canonical", href: "https://knowmeno.com/cookies" },
      { rel: "alternate", hrefLang: "en", href: "https://knowmeno.com/cookies" },
      { rel: "alternate", hrefLang: "x-default", href: "https://knowmeno.com/cookies" },
    ],
  }),
  component: () => (
    <TermlyPolicyPage dataId="6901b3c8-bf17-4673-aae2-f85d0c8cdfde" title="Cookie Policy" />
  ),
});
